module.exports = __webpack_public_path__ + "img/maleta-milhao.349ed7fa.jpeg";